module.exports = __webpack_public_path__ + "img/ry_4.c8d750fa.jpg";